import React, { useState } from 'react';
import { Col, Row, Collapse } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import Answer from './answer';
import { Rating } from 'react-simple-star-rating';
import { averageRating } from '../../Services/utils';

const QuestionnaireDisplay = ({ questions, isOpen, updateQuestionRating, toggleAccordion }) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  const editJobQuestion = (item) => {
    // Logic to edit the job question
  };

  return (
    <>
      {questions?.length > 0 && (
        <span onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
          <Row style={{ cursor: 'pointer' }} onClick={toggleAccordion}>
            <Col>
              <div className="form-horizontal pt-4">
                <div className="d-flex justify-content-between">
                  <h3>
                    <small>
                      <em className={isOpen ? 'fa fa-minus text-primary mr-2' : 'fa fa-plus text-primary mr-2'}></em>
                    </small>
                    {t('jobs.QUESTIONNAIRE')}
                  </h3>
                  <div className="d-flex align-items-center">
                    {/* {isHovered && (
                      <em
                        id={'pencilButtonJobDetailsQuestionnaire'}
                        style={{ cursor: 'pointer' }}
                        className="fa-2x mr-2 fas icon-pencil icon-hover-effect-no-color"
                        onClick={() => editJobQuestion()}
                      />
                    )} */}
                    <Rating initialValue={averageRating(questions)} size={25} readonly allowFraction />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Collapse isOpen={isOpen}>
            <Row>
              <Col>
                {questions.map((item, index) => (
                  <div key={index} className="pl-2">
                    <Answer index={index} item={item} onRating={updateQuestionRating} />
                  </div>
                ))}
              </Col>
            </Row>
          </Collapse>
        </span>
      )}
    </>
  );
};

export default QuestionnaireDisplay;
